import samsungglass from '../../assets/muvtech/Muvdata/SamsungGlass/ProShield-s25-s25ultra.png';

const samsungglassData = [
  {
    id: 1,
    type: 'samsungglass',
    title: 'Pro Shield Glass',
    compatibleModels: 'Samsung S25, S25 Ultra',
    price: 1999,
    specs: [],
    image: [samsungglass],
  },
];

export default samsungglassData;
